import { render, staticRenderFns } from "./addProperty.vue?vue&type=template&id=2df7643a&scoped=true"
import script from "./addProperty.vue?vue&type=script&lang=js"
export * from "./addProperty.vue?vue&type=script&lang=js"
import style0 from "./addProperty.vue?vue&type=style&index=0&id=2df7643a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7643a",
  null
  
)

export default component.exports